export default "__VITE_ASSET__pPTn9CQo__"